import { Capacitor } from "@capacitor/core";
import { isExternalSsoCallback, resolveDeepLinkTarget } from "~vue/deepLinks";
import { claimMobileSsoCallback } from "~vue/mobileSso";

let recovery: Promise<boolean> = Promise.resolve(false);

export function waitForMobileSsoRecovery(): Promise<boolean> {
    return recovery;
}

export function initializeMobileDeepLinks(): void {
    if (!Capacitor.isNativePlatform()) {
        return;
    }
    // Assign before mounting Landing, whose immediate watcher must await this.
    recovery = initialize();
    recovery.catch((error) => globalThis.reportError(error));
}

async function initialize(): Promise<boolean> {
    const { App } = await import("@capacitor/app");
    const supportsExternal = Capacitor.isPluginAvailable("MobileSso");
    let navigating = false;
    let handlingCallback: Promise<boolean> | undefined;
    const handleAppUrl = async ({ url }: { url: string }): Promise<boolean> => {
        const target = resolveDeepLinkTarget(url);
        if (target.kind === "sso-callback") {
            if (isExternalSsoCallback(url) && supportsExternal && !(await claimMobileSsoCallback(url))) {
                return false;
            }
            import("@capacitor/browser").then(({ Browser }) => Browser.close()).catch(() => {});
            if (target.loginPath) {
                navigating = true;
                globalThis.location.href = target.loginPath;
                return true;
            }
        } else if (target.kind === "navigate") {
            navigating = true;
            globalThis.location.href = target.href;
            return true;
        }
        return false;
    };
    await App.addListener("appUrlOpen", (event) => {
        handlingCallback = handleAppUrl(event);
        handlingCallback.catch((error) => globalThis.reportError(error));
    });
    if (supportsExternal) {
        const launchUrl = await App.getLaunchUrl();
        // A warm callback may arrive while getLaunchUrl is pending.
        if (handlingCallback && (await handlingCallback)) {
            return true;
        }
        if (launchUrl && isExternalSsoCallback(launchUrl.url)) {
            await handleAppUrl(launchUrl);
            // Also wait for a warm event that raced the native callback claim.
            await handlingCallback;
            return navigating;
        }
    }
    return false;
}
